(function () {
  var KEY = 'cello-recent-products';
  var MAX = 6;

  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  var productEl = document.getElementById('HeaderRecentProduct');
  if (productEl) {
    try {
      var product = JSON.parse(productEl.textContent);
      if (product && product.id) {
        var stored = getList().filter(function (item) { return item.id !== product.id; });
        stored.unshift(product);
        setList(stored.slice(0, MAX));
      }
    } catch (e) {}
  }

  var root = document.querySelector('header-recent');
  if (root) {
    var listEl = root.querySelector('[data-recent-list]');
    var emptyEl = root.querySelector('[data-recent-empty]');
    var countEl = root.querySelector('[data-recent-count]');
    var panel = root.querySelector('.header-recent__panel');
    var toggle = root.querySelector('.header-recent__toggle');
    var clearBtn = root.querySelector('[data-recent-clear]');
    var closeTimer;

    function isOpen() {
      return panel && !panel.classList.contains('hidden');
    }

    function openPanel() {
      clearTimeout(closeTimer);
      panel.classList.remove('is-closing', 'hidden');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      if (!isOpen() || panel.classList.contains('is-closing')) return;
      panel.classList.add('is-closing');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        panel.classList.add('hidden');
        panel.classList.remove('is-closing');
      }, 300);
    }

    function render() {
      var list = getList();
      if (countEl) {
        countEl.textContent = list.length;
        countEl.hidden = !list.length;
      }
      if (!list.length) {
        listEl.innerHTML = '';
        emptyEl.hidden = false;
        if (clearBtn) clearBtn.hidden = true;
        return;
      }
      emptyEl.hidden = true;
      if (clearBtn) clearBtn.hidden = false;
      listEl.innerHTML = list.map(function (item) {
        return '<li><a href="' + esc(item.url) + '">' +
          (item.image ? '<img src="' + esc(item.image) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="header-recent__ph"></span>') +
          '<span><strong>' + esc(item.title) + '</strong><em>' + esc(item.price) + '</em></span></a></li>';
      }).join('');
    }

    render();

    root.addEventListener('click', function (event) {
      event.stopPropagation();
      if (clearBtn && clearBtn.contains(event.target)) return;
      if (event.target.closest('a')) {
        closePanel();
        return;
      }
      if (panel.classList.contains('is-closing')) {
        openPanel();
        return;
      }
      if (isOpen()) closePanel();
      else openPanel();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanel();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        setList([]);
        render();
      });
    }
  }
})();
